import {useAui} from '@assistant-ui/react';
import {useCallback} from 'react';

import {useTrackWBAgentChats} from './useTrackWBAgent';

export function useNewChat(): () => void {
  const aui = useAui();
  const {trackChatCreated} = useTrackWBAgentChats();

  return useCallback(() => {
    aui.threads().switchToNewThread();
    trackChatCreated();
  }, [aui, trackChatCreated]);
}
